import { useEffect, useState } from "react";
import styles from "../CreatorsPage.module.scss";
import { img } from "./images";

const SCREENS = ["app-trip.webp", "app-list.webp"];

/** The phone in the hero: the trip screen and the list screen, crossfading every 4 seconds (not for visitors who ask for less motion). */
const HeroPhone = () => {
	const [shown, setShown] = useState(0);

	useEffect(() => {
		if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
		const timer = setInterval(() => setShown((current) => (current + 1) % SCREENS.length), 4000);
		return () => clearInterval(timer);
	}, []);

	return (
		<div className={styles.hphone}>
			{SCREENS.map((screen, i) => (
				<img key={screen} className={`${styles.hp} ${i === shown ? styles.on : ""}`} src={img(screen)} alt="" />
			))}
		</div>
	);
};

export default HeroPhone;
